import { graphql } from "@/lib/gql/__generated__/gql";

export const ExistingDummyRoomDefault_EditPage_Query = graphql(`
	query ExistingDummyRoomDefault_EditPage($hotelID: ID!, $roomId: ID!) {
		roomDummy(hotelID: $hotelID, roomID: $roomId) {
			id
			hotelID
			roomID
			inSale
			availablePlanIDs
			maxRoomNum
			capacityPeopleMaximum
			capacityAdultMaximum
			capacityKidsMaximum
			isKidsUnavailable
			kidsPolicy {
				kidsMaxAge
				kidsDiscountType
				ratio
				static {
					currencyType
					amount
				}
			}
			name
			catchCopy
			description
			mainKeyVisual {
				bucket
				key
				region
				mimeType
				fileName
			}
			keyVisuals {
				bucket
				key
				region
				mimeType
				fileName
			}
		}
		planList(hotelID: $hotelID) {
			id
			hotelID
			plans {
				planID
				name
				id
			}
			secrets {
				planID
				name
				id
			}
		}
	}
`);
